import { Link, useNavigate, useParams } from "react-router-dom";
import {
  UpdateOneData,
  capitalize,
  getDataWithFilterUrl,
  sendSubmissionUpdationAlert,
  separateDasFromUrl,
  updateFormSchemaWithRealtion,
} from "../../controllers/APIController";
// import { logMetricUpdated } from "../../utils/auditLogger";

import { Button, Input, Card, CardBody, CardHeader, Chip, Spinner, Textarea } from "@nextui-org/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from 'react-hot-toast';
import { 
  faBuilding, 
  faMapMarkerAlt, 
  faDollarSign, 
  faCog,
  faLink,
  faPhone,
  faGlobe,
  faCalendarAlt,
  faUser,
  faSave,
  faTimes,
  faChartLine,
  faCalculator
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState, useRef, useMemo, useCallback } from "react";
import {
  getFormulaData,
  getSchemaForOrg,
  updatedMetriclastUpdateResponse,
} from "../../utils/helper";
import {
  BooleanInput,
  DateInput,
  DropDownInput,
  IntegerInput,
  PasswordInput,
  RelationDropDownInput,
  SliderInput,
  TextAreaInput,
  TextInput,
} from "../FormBuilder/InputField/InputField";
import BreadCrumbsPage from "../../components/BreadCrumbsPage";
import { checkValidation } from "../../utils/checkValidation";
import FileEvidenceInput from "../FormBuilder/InputField/FileEvidenceInput";
import LogsInfo from "./LogsInfo";
import LoadingPage from "../../components/Loader/LoadingPage";
import { getSubheadingStructure } from "../../utils/formGrouping.utils";
import InfoToolTip from "../../components/utils/InfoToolTip";
import MetricFrameworkInfo from "./MetricFrameworkInfo";
import useGetOrgFramework from "../../hooks/useGetOrgFramework";

/* 
->I need to fetch the form Schema from Metric
->I need to fetch Form Data from Response
UpdateOneData(collectionName,id,data)
*/

const updateEvidenceRefrences = async (
  formdata,
  formschemaArray,
  referenceId,
  IntitaloformData
) => {
  const PromisesReponses = formschemaArray.map(async (row) => {
    if (row[1]?.type === "file") {
      let list1 = IntitaloformData[row[0]];
      let list2 = formdata[row[0]];

      list2 = list2?.filter((id) => !list1.includes(id));
      list1 = list1?.filter((id) => !list2.includes(id));

      const result1 = list2?.map(async (id) => {
        const uploadData = {
          ReferenceList: {
            connect: [+referenceId],
          },
        };

        return await UpdateOneData("evidences", +id, uploadData);
      });
      const result2 = list1?.map(async (id) => {
        const uploadData = {
          ReferenceList: {
            disconnect: [+referenceId],
          },
        };

        return await UpdateOneData("evidences", +id, uploadData);
      });
      return { result1, result2 };
    }
    return null;
  });

  await Promise.all(PromisesReponses);
};

const EditMetricForm = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { _orgId: currOrg, _categoryId, _metricId, _formId, id } = params;
  
  // Try to get the metric ID from different possible parameter names
  const metricId = _formId || id || params.id;
  
  console.log("🔍 All params received:", params);
  console.log("🔍 Metric ID resolved:", metricId);

  const [loader, setLoader] = useState(true);
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);
  const [isCalculating, setIsCalculating] = useState(false);
  const [calculationResults, setCalculationResults] = useState({});
  
  const [collectionInfo, setCollectionInfo] = useState();
  const [formdata, setFormData] = useState({});
  const [formSchema, setformSchema] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [groupedStructure, setGroupedStructure] = useState([]);
  const [description, setDescription] = useState("");
  const [links, setLinks] = useState([]);
  const [responseInfo, setResponseInfo] = useState();
  const [submittedUser, setSubmittedUser] = useState();
  const [initialFormData, setInitialFormData] = useState({});

  const formDataRef = useRef({});

  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
  const OrgInfo = UserLogged && UserLogged.user.LastOrgId;

  // Get organization framework details for dropdown options
  const { orgFrameworkDetails } = useGetOrgFramework(OrgInfo);

  // Utility function to normalize dropdown options consistently
  const normalizeDropdownOptions = useCallback((options) => {
    if (!options || !Array.isArray(options)) return [];
    
    const normalized = options.map(option => {
      const optionName = typeof option === 'string' ? option : option.name;
      return {
        original: option,
        normalized: optionName.trim(),
        display: optionName
      };
    });
    
    // Debug logging for normalization
    if (normalized.length > 0) {
      console.log(`🔧 Normalized dropdown options:`, normalized.map(opt => ({
        original: opt.display,
        normalized: opt.normalized
      })));
    }
    
    return normalized;
  }, []);

  // Helper function to get section icons
  const getSectionIcon = (sectionTitle) => {
    const title = sectionTitle?.toLowerCase() || '';
    
    if (title.includes('source') || title.includes('information')) return faBuilding;
    if (title.includes('activity') || title.includes('data')) return faChartLine;
    if (title.includes('financial') || title.includes('evidence')) return faDollarSign;
    if (title.includes('reporting') || title.includes('metadata')) return faCog;
    if (title.includes('emission') || title.includes('calculation')) return faCalculator;
    
    // Default icon
    return faCog;
  };

  const HeadingTitle = capitalize(separateDasFromUrl(_metricId));

  const metricFilteredUrl =
    "filters[Organization][id][$eqi]=" +
    OrgInfo +
      "&filters[Category][$eqi]=" +
    _categoryId.replaceAll("-", " ") +
      "&filters[Name][$eqi]=" +
    decodeURIComponent(_metricId).replaceAll("-", " ").replaceAll("&amp;", "&");

  // responseMetricUrl is no longer used - we fetch all responses and filter client-side

  const isFormulaVisiable =
    collectionInfo?.attributes?.JsonSchema?.formula?.length > 0 ? true : false;

  const changeHandler = (fieldName, value) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const clickHandler = (fieldName, value) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const testCalculationHandler = async () => {
    // Check if data is fully loaded
    if (!collectionInfo || !formdata || Object.keys(formdata).length === 0) {
      console.warn("Data not fully loaded yet. Please wait for the form to load completely.");
      toast.warning("Please wait for the form to load completely before testing calculations.");
      return;
    }
    
    // Check if formulas exist in the collection info
    const formulas = collectionInfo?.attributes?.JsonSchema?.formula;
    console.log("🔍 Formulas found:", formulas);
    console.log("🔍 Formulas type:", typeof formulas);
    console.log("🔍 Formulas isArray:", Array.isArray(formulas));
    
    if (!formulas || !Array.isArray(formulas) || formulas.length === 0) {
      console.warn("No formulas found for calculation");
      setCalculationResults({ error: "No calculation formulas found for this metric." });
      return;
    }
    
    console.log("🔍 Form data for calculation:", formdata);
    console.log("🔍 Formulas to process:", formulas);
    
    setIsCalculating(true);
    try {
      const results = await getFormulaData(formulas, formdata);
      setCalculationResults(results);
      console.log("Calculation results:", results);
    } catch (error) {
      console.error("Calculation error:", error);
      setCalculationResults({ error: "Calculation failed. Please check your input data." });
    } finally {
      setIsCalculating(false);
    }
  };

  const submitHandler = async () => {
    if (isSubmittingForm) return;

    // Validate form data first (synchronous operation)
    const validationResult = checkValidation(formSchema, formdata);
    if (!validationResult.isValid) {
      setValidationErrors(validationResult.errors);
      toast.error("Please fix the validation errors before submitting.");
      return;
    }

    setIsSubmittingForm(true);
    
    try {
      const uploadData = {
        JsonSchema: formdata,
      };

      // Determine the correct response ID to update
      const responseIdToUpdate = responseInfo?.id || metricId;
      console.log("🔍 Updating response with ID:", responseIdToUpdate);
      
      const result = await UpdateOneData("responses", responseIdToUpdate, uploadData);
      if (result.success) {
        await updateEvidenceRefrences(
          formdata,
          formSchema,
          responseIdToUpdate,
          initialFormData
        );
        
        await updatedMetriclastUpdateResponse(responseIdToUpdate);
        await sendSubmissionUpdationAlert(responseIdToUpdate);
        
        toast.success("Metric updated successfully!");
        navigate(`/${currOrg}/metrics/${_categoryId}/${_metricId}`);
      } else {
        toast.error("Failed to update metric. Please try again.");
      }
    } catch (error) {
      console.error("Submit error:", error);
      toast.error("An error occurred while updating the metric.");
    } finally {
      setIsSubmittingForm(false);
    }
  };

  useEffect(() => {
    console.log("🔍 EditMetricForm useEffect triggered");
    console.log("🔍 URL params:", { currOrg, _categoryId, _metricId, _formId, id });
    console.log("🔍 Resolved metricId:", metricId);
    console.log("🔍 OrgInfo:", OrgInfo);

    // Check if we have the required parameters
    if (!OrgInfo || !metricFilteredUrl) {
      console.log("⏭️ Missing required parameters, skipping API calls");
      setLoader(false);
      return;
    }

    // Validate that the metricId parameter is valid
    if (!metricId || metricId === 'undefined' || metricId === 'null' || isNaN(parseInt(metricId))) {
      console.error("❌ Invalid metric ID:", metricId);
      toast.error("Invalid metric ID. Please check the URL.");
      setLoader(false);
      return;
    }

    console.log("🔍 Starting data fetch process...");

    // Step 1: Fetch the metric schema
    getDataWithFilterUrl("metrics", metricFilteredUrl)
      .then((metricData) => {
        console.log("🔍 Metrics API response:", metricData);
        
        if (!metricData?.data?.[0]) {
          console.error("❌ No metric found");
          toast.error("Metric not found. Please check the URL.");
          setLoader(false);
          return;
        }

        const metric = metricData.data[0];
        console.log("🔍 Found metric:", metric.attributes?.Name);
        
        setCollectionInfo(metric);
        setDescription(metric.attributes?.Description);
        setLinks(metric.attributes?.Links?.Links || []);

        // Process the schema
        const responseData = metric.attributes?.JsonSchema?.properties;
        console.log("🔍 JsonSchema properties:", responseData);

        getSchemaForOrg(responseData, OrgInfo).then((schemaData) => {
          console.log("🔍 Schema data from getSchemaForOrg:", schemaData);
          
          // Add formula fields to the form schema
          const formulaFields = metric.attributes?.JsonSchema?.formula?.map((formula) => [
            formula.title,
            {
              ...formula,
              type: "formula",
              title: formula.title,
            }
          ]) || [];
          
          const completeSchema = [...schemaData, ...formulaFields];
          console.log("🔍 Complete schema:", completeSchema);
          
          // Debug schema field names
          console.log("🔍 Schema field names:", completeSchema.map(([name, config]) => ({ name, type: config.type })));
          
          setformSchema(completeSchema);
          
          // Group fields by subheadings
          const structure = getSubheadingStructure(completeSchema);
          console.log("🔍 Grouped structure:", structure);
          setGroupedStructure(structure);
        });

        // Step 2: Try to fetch the existing response by ID
        console.log("🔍 Attempting to fetch response by ID:", metricId);
        
        getDataWithFilterUrl("responses", `filters[id][$eqi]=${metricId}`)
          .then((responseData) => {
            console.log("🔍 Response API response:", responseData);
            
            if (responseData?.data?.[0]) {
              // Found existing response - load the data
              const response = responseData.data[0];
              console.log("🔍 Found existing response:", response.id);
              
              setResponseInfo(response);
              setSubmittedUser(response.attributes?.users_permissions_user?.data);
              
              let responseFormData = response.attributes?.JsonSchema;
              
              // Handle new grouped structure or legacy format
              if (responseFormData?.flatData) {
                responseFormData = responseFormData.flatData;
              }

              // Clean up null values
              Object.keys(responseFormData || {}).forEach((key) => {
                if (responseFormData[key] === "null") {
                  responseFormData[key] = "";
                }
              });

              console.log("🔍 Raw response form data:", responseFormData);
              console.log("🔍 Form data keys:", Object.keys(responseFormData || {}));
              console.log("🔍 Sample field values:", Object.entries(responseFormData || {}).slice(0, 5));
              
              // Check if we have the expected field structure
              if (responseFormData) {
                console.log("🔍 Checking field structure...");
                Object.keys(responseFormData).forEach(key => {
                  console.log(`  ${key}:`, responseFormData[key], `(type: ${typeof responseFormData[key]})`);
                });
              }

              // Synchronize the form data with the schema to ensure field names match
              const synchronizedData = synchronizeFormDataWithSchema(formSchema, responseFormData);
              setFormData(synchronizedData || {});
              formDataRef.current = synchronizedData || {};
              setInitialFormData(synchronizedData);
              
              // Validate dropdown values to ensure they exist in the available options
              const dropdownValidation = validateDropdownValues(formSchema, synchronizedData);
              if (Object.keys(dropdownValidation).length > 0) {
                console.warn("⚠️ Dropdown validation issues found:", dropdownValidation);
              }
              
              console.log("🔍 Loaded existing form data");
            } else {
              // No existing response found - create new form
              console.log("🔍 No existing response found - creating new form");
              
              setResponseInfo(null);
              setSubmittedUser(null);
              setFormData({});
              formDataRef.current = {};
              setInitialFormData({});
              
              console.log("🔍 New form initialized");
            }
            
            setLoader(false);
          })
          .catch((responseError) => {
            console.error("❌ Error fetching response:", responseError);
            console.log("🔍 Falling back to new form creation");
            
            // Fallback to new form
            setResponseInfo(null);
            setSubmittedUser(null);
            setFormData({});
            formDataRef.current = {};
            setInitialFormData({});
            setLoader(false);
          });
      })
      .catch((metricError) => {
        console.error("❌ Error fetching metric:", metricError);
        toast.error("Failed to load metric. Please refresh the page.");
        setLoader(false);
      });

    // Cleanup function
    return () => {
      console.log("🔍 EditMetricForm useEffect cleanup");
    };
  }, [OrgInfo, metricFilteredUrl, loader]);

  // Synchronize form data with field schema to ensure dropdowns work correctly
  const synchronizeFormDataWithSchema = useCallback((schema, existingData) => {
    if (!schema || !existingData) return existingData;
    
    const synchronizedData = { ...existingData };
    
    schema.forEach(([fieldName, fieldConfig]) => {
      // Check if this field has existing data
      if (existingData[fieldName] !== undefined) {
        // Field exists, keep the value
        console.log(`✅ Field "${fieldName}" has existing value:`, existingData[fieldName]);
      } else if (existingData[fieldConfig.title] !== undefined) {
        // Field exists with title as key, migrate it
        console.log(`🔄 Migrating field "${fieldConfig.title}" to "${fieldName}":`, existingData[fieldConfig.title]);
        synchronizedData[fieldName] = existingData[fieldConfig.title];
        delete synchronizedData[fieldConfig.title];
      } else {
        // Field doesn't exist, initialize with empty value
        console.log(`🆕 Initializing field "${fieldName}" with empty value`);
        synchronizedData[fieldName] = "";
      }
    });
    
    console.log("🔍 Synchronized form data:", synchronizedData);
    return synchronizedData;
  }, []);

  // Keep the ref in sync with formdata state
  useEffect(() => {
    formDataRef.current = formdata;
  }, [formdata]);

  // Synchronize form data when schema changes to ensure dropdowns work correctly
  useEffect(() => {
    if (formSchema && formSchema.length > 0 && initialFormData && Object.keys(initialFormData).length > 0) {
      console.log("🔄 Schema changed, synchronizing form data...");
      const synchronizedData = synchronizeFormDataWithSchema(formSchema, initialFormData);
      setFormData(synchronizedData);
      formDataRef.current = synchronizedData;
    }
  }, [formSchema, initialFormData, synchronizeFormDataWithSchema]);

  // Validate dropdown field values to ensure they exist in the available options
  const validateDropdownValues = useCallback((schema, formData) => {
    const validationResults = {};
    
    schema.forEach(([fieldName, fieldConfig]) => {
      if (fieldConfig.type === "dropdown") {
        const fieldValue = formData[fieldName];
        const dropdownOptions = fieldConfig.values || fieldConfig.value || [];
        
        if (fieldValue && fieldValue !== "") {
          // Normalize dropdown options by trimming whitespace
          const normalizedOptions = normalizeDropdownOptions(dropdownOptions);
          
          // Check for exact match first
          const exactMatch = normalizedOptions.find(option => 
            option.normalized === fieldValue.trim()
          );
          
          // If no exact match, try case-insensitive match
          const caseInsensitiveMatch = !exactMatch ? normalizedOptions.find(option => 
            option.normalized.toLowerCase() === fieldValue.trim().toLowerCase()
          ) : null;
          
          // If still no match, try fuzzy match (ignoring leading/trailing spaces)
          const fuzzyMatch = !exactMatch && !caseInsensitiveMatch ? normalizedOptions.find(option => 
            option.normalized.toLowerCase() === fieldValue.toLowerCase()
          ) : null;
          
          const hasMatchingOption = exactMatch || caseInsensitiveMatch || fuzzyMatch;
          
          if (!hasMatchingOption) {
            validationResults[fieldName] = {
              type: "dropdown_mismatch",
              message: `Value "${fieldValue}" not found in dropdown options`,
              availableOptions: normalizedOptions.map(opt => opt.display),
              normalizedOptions: normalizedOptions.map(opt => opt.normalized),
              suggestions: getDropdownValueSuggestions(fieldValue, normalizedOptions.map(opt => opt.normalized))
            };
            console.warn(`⚠️ Dropdown validation failed for "${fieldName}":`, validationResults[fieldName]);
          } else {
            console.log(`✅ Dropdown validation passed for "${fieldName}":`, fieldValue);
          }
        }
      }
    });
    
    return validationResults;
  }, [normalizeDropdownOptions]);

  // Get suggestions for fixing dropdown value mismatches
  const getDropdownValueSuggestions = useCallback((currentValue, availableOptions) => {
    if (!currentValue || !availableOptions || availableOptions.length === 0) return [];
    
    const suggestions = [];
    const currentValueLower = currentValue.toLowerCase();
    
    // Try exact match first
    const exactMatch = availableOptions.find(option => {
      const optionName = typeof option === 'string' ? option : option.name;
      return optionName.toLowerCase() === currentValueLower;
    });
    if (exactMatch) {
      suggestions.push({
        type: 'exact_match',
        value: typeof exactMatch === 'string' ? exactMatch : exactMatch.name,
        confidence: 'high'
      });
    }
    
    // Try partial matches
    const partialMatches = availableOptions.filter(option => {
      const optionName = typeof option === 'string' ? option : option.name;
      return optionName.toLowerCase().includes(currentValueLower) || 
             currentValueLower.includes(optionName.toLowerCase());
    }).slice(0, 3); // Limit to 3 suggestions
    
    partialMatches.forEach(option => {
      const optionName = typeof option === 'string' ? option : option.name;
      if (optionName.toLowerCase() !== currentValueLower) {
        suggestions.push({
          type: 'partial_match',
          value: optionName,
          confidence: 'medium'
        });
      }
    });
    
    return suggestions;
  }, [normalizeDropdownOptions]);

  // Convert formSchema to fieldInfoList format for FormFieldArranger
  const getFieldInfoList = () => {
    if (!formSchema || formSchema.length === 0) return [];
    
    return formSchema.map(([fieldName, fieldConfig], index) => ({
      id: fieldName,
      key: fieldName,
      config: fieldConfig,
      title: fieldConfig.title || fieldName,
      type: fieldConfig.type,
      Required: fieldConfig.Required || false,
      visualOrder: index,
      originalOrder: index
    }));
  };

  const renderField = (fieldEntry, fieldKey, index) => {
    if (!fieldEntry || fieldEntry.length !== 2) {
      console.warn("Invalid field entry:", fieldEntry);
      return null;
    }

    const [fieldName, fieldConfig] = fieldEntry;
    
    // Enhanced field value resolution with fallbacks
    let fieldValue = "";
    
    // Try multiple ways to get the field value
    if (formdata && formdata[fieldName] !== undefined) {
      fieldValue = formdata[fieldName];
    } else if (formdata && formdata[fieldConfig.title] !== undefined) {
      // Fallback: try using the title as the key
      fieldValue = formdata[fieldConfig.title];
      console.log(`🔍 Using title as fallback key for ${fieldName}:`, fieldConfig.title);
    } else if (initialFormData && initialFormData[fieldName] !== undefined) {
      // Fallback: try initial form data
      fieldValue = initialFormData[fieldName];
      console.log(`🔍 Using initialFormData for ${fieldName}:`, fieldValue);
    }
    
    // Normalize the value
    if (fieldValue === "null" || fieldValue === null) {
      fieldValue = "";
    }
    
    // Debug dropdown fields specifically with enhanced logging
    if (fieldConfig.type === "dropdown") {
      console.log("🔍 Rendering dropdown field:", {
        fieldName,
        fieldConfigTitle: fieldConfig.title,
        fieldValue,
        fieldValueType: typeof fieldValue,
        formDataKeys: Object.keys(formdata || {}),
        initialFormDataKeys: Object.keys(initialFormData || {}),
        hasOrgFramework: !!orgFrameworkDetails,
        orgFrameworkLength: orgFrameworkDetails?.length || 0,
        dropdownValues: fieldConfig.values || fieldConfig.value,
        dropdownValuesCount: (fieldConfig.values || fieldConfig.value)?.length || 0
      });
      
      // Check if the field value exists in the dropdown options using normalized comparison
      const dropdownOptions = fieldConfig.values || fieldConfig.value || [];
      const normalizedOptions = normalizeDropdownOptions(dropdownOptions);
      
      // Use the same matching logic as validateDropdownValues
      const exactMatch = normalizedOptions.find(option => 
        option.normalized === fieldValue.trim()
      );
      const caseInsensitiveMatch = !exactMatch ? normalizedOptions.find(option => 
        option.normalized.toLowerCase() === fieldValue.trim().toLowerCase()
      ) : null;
      const fuzzyMatch = !exactMatch && !caseInsensitiveMatch ? normalizedOptions.find(option => 
        option.normalized.toLowerCase() === fieldValue.toLowerCase()
      ) : null;
      
      const hasMatchingOption = exactMatch || caseInsensitiveMatch || fuzzyMatch;
      
      if (fieldValue && !hasMatchingOption) {
        console.warn(`⚠️ Field value "${fieldValue}" not found in dropdown options for field "${fieldName}"`);
        console.warn(`Available options:`, normalizedOptions.map(opt => opt.display));
        
        // Get suggestions for fixing the mismatch
        const suggestions = getDropdownValueSuggestions(fieldValue, normalizedOptions.map(opt => opt.normalized));
        if (suggestions.length > 0) {
          console.log(`💡 Suggestions for "${fieldName}":`, suggestions);
        }
      }
    }

    switch (fieldConfig.type) {
      case "string":
      case "text":
        return (
          <div key={fieldKey} className="mb-4">
            <TextInput
              data={fieldConfig}
              value={fieldValue}
              validationErrors={validationErrors}
              onChangeHandler={changeHandler}
              cssStyle="mb-0"
            />
          </div>
        );
      case "password":
        return (
          <div key={fieldKey} className="mb-4">
            <PasswordInput
              data={fieldConfig}
              value={fieldValue}
              validationErrors={validationErrors}
              onChangeHandler={changeHandler}
              cssStyle="mb-0"
            />
          </div>
        );
      case "integer":
        return (
          <div key={fieldKey} className="mb-4">
            <IntegerInput
              data={fieldConfig}
              value={fieldValue}
              validationErrors={validationErrors}
              onChangeHandler={changeHandler}
              cssStyle="mb-0"
            />
          </div>
        );
      case "dropdown":
        // Check for dropdown value mismatch using normalized comparison
        const dropdownOptions = fieldConfig.values || fieldConfig.value || [];
        const normalizedOptions = normalizeDropdownOptions(dropdownOptions);
        
        // Use the same matching logic as validateDropdownValues
        const exactMatch = normalizedOptions.find(option => 
          option.normalized === fieldValue.trim()
        );
        const caseInsensitiveMatch = !exactMatch ? normalizedOptions.find(option => 
          option.normalized.toLowerCase() === fieldValue.trim().toLowerCase()
        ) : null;
        const fuzzyMatch = !exactMatch && !caseInsensitiveMatch ? normalizedOptions.find(option => 
          option.normalized.toLowerCase() === fieldValue.toLowerCase()
        ) : null;
        
        const hasMatchingOption = exactMatch || caseInsensitiveMatch || fuzzyMatch;
        
        return (
          <div key={fieldKey} className="mb-4">
            <DropDownInput
              data={fieldConfig}
              value={fieldValue}
              orgFrameworkDetails={orgFrameworkDetails}
              validationErrors={validationErrors}
              onChangeHandler={changeHandler}
              buttonCSS="mb-0"
            />
            
            {/* Show warning if value doesn't match available options */}
            {fieldValue && !hasMatchingOption && (
              <div className="mt-2 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                <div className="flex items-start gap-2">
                  <span className="text-amber-600 mt-0.5">⚠️</span>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-amber-800 mb-1">
                      Value mismatch detected
                    </p>
                    <p className="text-xs text-amber-700 mb-2">
                      Current value "{fieldValue}" is not available in the dropdown options.
                    </p>
                    
                    {/* Show suggestions */}
                    {(() => {
                      const suggestions = getDropdownValueSuggestions(fieldValue, normalizedOptions.map(opt => opt.normalized));
                      if (suggestions.length > 0) {
                        return (
                          <div>
                            <p className="text-xs text-amber-600 mb-1">Suggested alternatives:</p>
                            <div className="flex flex-wrap gap-1">
                              {suggestions.slice(0, 3).map((suggestion, idx) => (
                                <button
                                  key={idx}
                                  onClick={() => changeHandler(fieldName, suggestion.value)}
                                  className="text-xs px-2 py-1 bg-amber-100 hover:bg-amber-200 text-amber-800 rounded border border-amber-300 transition-colors"
                                >
                                  {suggestion.value}
                                </button>
                              ))}
                            </div>
                          </div>
                        );
                      }
                      return null;
                    })()}
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      case "slider":
        return (
          <div key={fieldKey} className="mb-4">
            <SliderInput
              data={fieldConfig}
              value={fieldValue}
              validationErrors={validationErrors}
              onChangeHandler={changeHandler}
            />
          </div>
        );
      case "boolean":
        return (
          <div key={fieldKey} className="mb-4">
            <BooleanInput
              data={fieldConfig}
              value={fieldValue}
              validationErrors={validationErrors}
              onChangeHandler={changeHandler}
              cssStyle="mb-0"
            />
          </div>
        );
      case "date":
        return (
          <div key={fieldKey} className="mb-4">
            <DateInput
              data={fieldConfig}
              value={fieldValue}
              validationErrors={validationErrors}
              onChangeHandler={changeHandler}
              cssStyle="mb-0"
            />
          </div>
        );
      case "file":
        return (
          <div key={fieldKey} className="md:col-span-2 mb-4">
            <FileEvidenceInput
              data={fieldConfig}
              value={fieldValue}
              validationErrors={validationErrors}
              onChangeHandler={changeHandler}
              cssStyle="mb-0"
            />
          </div>
        );
      case "textarea":
        return (
          <div key={fieldKey} className="mb-4">
            <TextAreaInput
              data={fieldConfig}
              value={fieldValue}
              validationErrors={validationErrors}
              onChangeHandler={changeHandler}
              cssStyle="mb-0"
            />
          </div>
        );
      case "relation":
        return (
          <RelationDropDownInput
            key={fieldKey}
            data={fieldConfig}
            value={fieldValue}
            orgFrameworkDetails={orgFrameworkDetails}
            validationErrors={validationErrors}
            onChangeHandler={changeHandler}
            onClickHandler={clickHandler}
          />
        );
      case "formula":
        return (
          <div key={fieldKey} className="mb-4">
            <div className="p-4 bg-emerald-50 border border-emerald-200 rounded-lg">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-emerald-600">🧮</span>
                <span className="font-medium text-emerald-800">{fieldConfig.title}</span>
              </div>
              <p className="text-sm text-emerald-700">
                This field will be calculated automatically based on the formula.
              </p>
            </div>
          </div>
        );
      default:
        console.warn(`⚠️ Unknown field type "${fieldConfig.type}" for field "${fieldName}"`);
        return (
          <div key={fieldKey} className="mb-4">
            <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg">
              <p className="text-gray-600">
                Unknown field type: {fieldConfig.type} for {fieldConfig.title || fieldName}
              </p>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Enhanced Page Header */}
      <div className="bg-white border-b border-neutral-200 px-6 py-6 shadow-sm">
        <div className="flex items-center justify-between max-w-full">
          <div className="flex items-center gap-4">
            {/* Metric Category Badge */}
            <div className="flex items-center gap-2">
              <div className="w-2 h-8 bg-emerald-500 rounded-full"></div>
              <div className="flex flex-col">
                <div className="flex items-center gap-3 mb-2">
                  <h1 className="text-2xl font-bold text-neutral-900">
                    {HeadingTitle}
                  </h1>
                  <Chip 
                    color="success" 
                    variant="flat" 
                    size="sm" 
                    className="text-xs font-semibold bg-emerald-100 text-emerald-800 border-emerald-200"
                  >
                    Active
                  </Chip>
                </div>
                {/* Enhanced Description with Context */}
                <div className="flex items-center gap-3 text-sm text-neutral-600">
                  <span className="font-medium">Category:</span>
                  <Chip 
                    color="default" 
                    variant="bordered" 
                    size="sm" 
                    className="text-xs bg-neutral-50 border-neutral-200 text-neutral-700"
                  >
                    {_categoryId?.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                  </Chip>
                  <span className="text-neutral-400">•</span>
                  <span>GHG Emissions • Stationary Combustion</span>
                </div>
                <p className="text-base text-neutral-600 max-w-3xl leading-relaxed mt-2">
                  Modify and manage your {HeadingTitle.toLowerCase()} metric data, calculations, and reporting standards. Keep your metric details up to date for accurate ESG reporting.
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <Button
              color="danger"
              variant="bordered"
              startContent={<FontAwesomeIcon icon={faTimes} className="text-sm" />}
              onClick={() => navigate(`/${currOrg}/metrics/${_categoryId}/${_metricId}`)}
              size="sm"
              className="px-4 py-2 border border-red-300 hover:border-red-400 hover:bg-red-50 transition-all duration-200"
            >
              Cancel
            </Button>
            <Button
              color="success"
              className="enhanced-button text-white px-6 py-2 font-semibold shadow-md hover:shadow-lg"
              startContent={<FontAwesomeIcon icon={faSave} className="text-white text-sm" />}
              onClick={submitHandler}
              size="sm"
              isLoading={isSubmittingForm}
            >
              Save Changes
            </Button>
          </div>
        </div>
      </div>

      <BreadCrumbsPage>
        <div className="max-w-7xl mx-auto px-8 py-2">
          <LoadingPage isLoading={loader}>
            {/* Enhanced Form Container */}
            <div className="bg-white rounded-xl border border-neutral-200 shadow-sm overflow-hidden">
              {/* Enhanced Description Header */}
              <div className="px-6 py-6 border-b border-neutral-200 bg-gradient-to-r from-emerald-50 to-neutral-50">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-1 h-6 bg-emerald-500 rounded-full"></div>
                  <h2 className="text-xl font-semibold text-neutral-900">Metric Overview</h2>
                  <Chip 
                    color="success" 
                    variant="flat" 
                    size="sm" 
                    className="text-xs bg-emerald-100 text-emerald-800"
                  >
                    Edit Entry
                  </Chip>
                </div>
                <p className="text-sm text-neutral-600 leading-relaxed max-w-3xl mb-4">
                  {description ||
                    `No description is available at the moment. Please check back later for updates.`}
                </p>
                <div className="mt-4">
                  <MetricFrameworkInfo
                    CollectionInfo={collectionInfo}
                    orgFrameworkDetails={null}
                  />
                </div>
              </div>
              
              {/* Enhanced Form Sections */}
              <div className="p-6">
                <div
                  className="p-6 compact-form"
                  style={{
                    opacity: isSubmittingForm ? 0.8 : 1,
                    fontSize: "0.875rem",
                  }}
                >
                  {/* Enhanced Form Styling */}
                  <div className="space-y-8">
                    <style>{`
                    /* Compact Form Field Styling using unified design system */
                                          .compact-form .nextui-input-wrapper {
                        min-height: 44px !important;
                        background: var(--color-neutral-50, #fafafa) !important;
                        border: 1px solid var(--color-neutral-300, #d4d4d4) !important;
                        border-radius: var(--radius-md, 0.5rem) !important;
                      transition: all 0.2s ease !important;
                      box-shadow: var(--shadow-sm, 0 1px 2px rgba(0, 0, 0, 0.05)) !important;
                    }
                    
                    .compact-form .nextui-input-wrapper:hover {
                      border-color: var(--color-neutral-400, #a3a3a3) !important;
                      box-shadow: var(--shadow-md, 0 2px 4px rgba(0, 0, 0, 0.1)) !important;
                    }
                    
                    .compact-form .nextui-input-wrapper:focus-within {
                      border-color: var(--color-primary-500, #10b981) !important;
                      box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1) !important;
                    }
                    
                    .compact-form .nextui-input {
                      font-size: var(--font-size-sm, 0.875rem) !important;
                      background: transparent !important;
                      border: none !important;
                      box-shadow: none !important;
                    }
                    
                    .compact-form .nextui-input-label {
                      font-size: var(--font-size-sm, 0.875rem) !important;
                      font-weight: var(--font-weight-semibold, 600) !important;
                      color: var(--color-neutral-700, #404040) !important;
                      margin-bottom: var(--spacing-xs, 0.25rem) !important;
                      letter-spacing: 0.025em !important;
                    }
                    
                    .compact-form .nextui-select-wrapper {
                      min-height: 44px !important;
                      background: var(--color-neutral-50, #fafafa) !important;
                      border: 1px solid var(--color-neutral-300, #d4d4d4) !important;
                      border-radius: var(--radius-md, 0.5rem) !important;
                      transition: all 0.2s ease !important;
                      box-shadow: var(--shadow-sm, 0 1px 2px rgba(0, 0, 0, 0.05)) !important;
                    }
                    
                    .compact-form .nextui-select-wrapper:hover {
                      border-color: var(--color-neutral-400, #a3a3a3) !important;
                      box-shadow: var(--shadow-md, 0 2px 4px rgba(0, 0, 0, 0.1)) !important;
                    }
                    
                    .compact-form .nextui-select-wrapper:focus-within {
                      border-color: var(--color-primary-500, #10b981) !important;
                      box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1) !important;
                    }
                    
                    .compact-form .nextui-select-trigger {
                      font-size: var(--font-size-sm, 0.875rem) !important;
                      background: transparent !important;
                      border: none !important;
                      box-shadow: none !important;
                    }
                    
                    .compact-form .nextui-textarea {
                      font-size: var(--font-size-sm, 0.875rem) !important;
                      background: transparent !important;
                      border: none !important;
                      box-shadow: none !important;
                    }
                    
                    /* Enhanced Section Containers matching CreateMetricForm */
                    .section-container {
                      background: #ffffff;
                      border: 1px solid #e5e7eb;
                      border-radius: 12px;
                      padding: 24px;
                      margin-bottom: 24px;
                      transition: all 0.2s ease;
                      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
                    }
                    
                    .section-container::before {
                      content: none;
                    }
                    
                    .section-container:hover {
                      border-color: #d1d5db;
                      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                      transform: translateY(-1px);
                    }
                    
                    .section-header {
                      background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
                      border: 1px solid #e5e7eb;
                      border-radius: 8px;
                      padding: 20px 24px;
                      margin-bottom: 24px;
                      display: flex;
                      align-items: center;
                      gap: 16px;
                      position: relative;
                      overflow: hidden;
                    }
                    
                    .section-header::before {
                      content: '';
                      position: absolute;
                      top: 0;
                      left: 0;
                      right: 0;
                      height: 3px;
                      background: linear-gradient(90deg, #10b981 0%, #059669 100%);
                    }
                    
                    .section-header-icon {
                      width: 40px;
                      height: 40px;
                      background: linear-gradient(135deg, #10b981 0%, #059669 100%);
                      border-radius: 8px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      color: white;
                      font-size: 18px;
                      box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
                      transition: all 0.2s ease;
                    }
                    
                    .section-header-icon:hover {
                      transform: scale(1.05);
                      box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
                    }
                    
                    .section-header-content h3 {
                      font-size: 1rem;
                      font-weight: 600;
                      color: #111827;
                      margin: 0;
                    }
                    
                    .section-header-content p {
                      font-size: 0.875rem;
                      color: #6b7280;
                      margin: 2px 0 0 0;
                    }
                    
                    /* Enhanced Field Wrappers matching CreateMetricForm */
                    .field-wrapper {
                      transition: all 0.2s ease;
                      min-height: 120px;
                      height: auto;
                      display: flex;
                      flex-direction: column;
                      position: relative;
                      background: #ffffff;
                      border: 1px solid #f3f4f6;
                      border-radius: 8px;
                      padding: 16px;
                      margin-bottom: 16px;
                    }
                    
                    .field-wrapper:hover {
                      border-color: #e5e7eb;
                      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
                      transform: translateY(-1px);
                    }
                    
                    .field-container {
                      height: 100%;
                      display: flex;
                      flex-direction: column;
                      justify-content: space-between;
                      gap: 8px;
                    }
                    
                    .field-container .nextui-input-label,
                    .field-container .nextui-select-label {
                      font-size: 0.875rem !important;
                      font-weight: 600 !important;
                      color: #374151 !important;
                      margin-bottom: 8px !important;
                    }
                    
                    .field-container .nextui-input-wrapper,
                    .field-container .nextui-select-wrapper,
                    .field-container .nextui-textarea-wrapper {
                      background: #ffffff !important;
                      border: 1px solid #d1d5db !important;
                      border-radius: 6px !important;
                      transition: all 0.2s ease !important;
                    }
                    
                    .field-container .nextui-input-wrapper:hover,
                    .field-container .nextui-select-wrapper:hover,
                    .field-container .nextui-textarea-wrapper:hover {
                      border-color: #9ca3af !important;
                      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
                    }
                    
                    .field-container .nextui-input-wrapper:focus-within,
                    .field-container .nextui-select-wrapper:focus-within,
                    .field-container .nextui-textarea-wrapper:focus-within {
                      border-color: #10b981 !important;
                      box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1) !important;
                    }
                    
                    /* Enhanced Button Styling */
                    .enhanced-button {
                      background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
                      border: none !important;
                      border-radius: 8px !important;
                      box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3) !important;
                      transition: all 0.2s ease !important;
                    }
                    
                    .enhanced-button:hover {
                      background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;
                      box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4) !important;
                      transform: translateY(-1px) !important;
                    }
                    
                    /* Enhanced Card Shadows and Borders */
                    .card-enhanced {
                      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1) !important;
                      border: 1px solid #e5e7eb !important;
                      border-radius: 12px !important;
                      transition: all 0.2s ease !important;
                    }
                    
                    .card-enhanced:hover {
                      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06) !important;
                      transform: translateY(-2px) !important;
                    }
                    
                    /* Compact Validation States */
                    .field-error {
                      background: #fef2f2;
                      border: 1px solid #fecaca;
                      border-radius: 6px;
                      padding: 8px 12px;
                      margin-top: 6px;
                      display: flex;
                      align-items: center;
                      gap: 6px;
                      font-size: 0.75rem;
                      color: #dc2626;
                    }
                    
                    /* Enhanced Typography */
                    .field-title {
                      font-size: 1.25rem;
                      font-weight: 700;
                      color: #111827;
                      margin-bottom: 20px;
                      display: flex;
                      align-items: center;
                      gap: 12px;
                      letter-spacing: -0.025em;
                    }
                    
                    .field-title::before {
                      content: '';
                      width: 4px;
                      height: 24px;
                      background: linear-gradient(180deg, #10b981 0%, #059669 100%);
                      border-radius: 2px;
                      box-shadow: 0 1px 3px rgba(16, 185, 129, 0.3);
                    }
                    
                    /* Enhanced Section Content */
                    .section-content {
                      background: #ffffff;
                      border-radius: 8px;
                      padding: 20px;
                      margin-top: 16px;
                    }
                    
                    /* Enhanced Grid Layout */
                    .enhanced-grid {
                      display: grid;
                      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                      gap: 24px;
                      align-items: start;
                    }
                    
                    /* Info Pill Styling */
                    .info-pill {
                      display: inline-flex !important;
                      align-items: center;
                      gap: 6px;
                      background: #f3f4f6;
                      border: 1px solid #d1d5db;
                      border-radius: 16px;
                      padding: 4px 12px;
                      margin-top: 6px;
                      font-size: 0.75rem;
                      color: #6b7280;
                      transition: all 0.2s ease;
                      width: fit-content;
                    }
                    
                    .info-pill:hover {
                      background: #e5e7eb;
                      border-color: #9ca3af;
                    }
                    
                    /* Field Alignment */
                    .field-container {
                      display: flex;
                      flex-direction: column;
                      width: 100%;
                    }
                    
                    .field-row {
                      display: flex;
                      align-items: flex-start;
                      gap: 12px;
                      width: 100%;
                    }
                    
                    .field-main {
                      flex: 1;
                      min-width: 0;
                    }
                    
                    .field-info {
                      flex-shrink: 0;
                      margin-top: 32px;
                        }
                      `}</style>

                  {/* Form Content */}
                  <div className="space-y-6">
                    {(() => {
                      const subheadingStructure = getSubheadingStructure(formSchema);
                      
                      return subheadingStructure.map((section, sectionIndex) => (
                        <div key={`section-${sectionIndex}`} className="section-container">
                          {/* Enhanced Section Header */}
                          <div className="section-header">
                            <div className="section-header-icon">
                              <FontAwesomeIcon icon={getSectionIcon(section.subheading.title)} />
                            </div>
                            <div className="section-header-content">
                              <h3 className="field-title text-xl mb-0">
                                {section.subheading.title}
                              </h3>
                              {section.subheading.description && (
                                <p className="text-sm text-neutral-600 mt-2 leading-relaxed">
                                  {section.subheading.description}
                                </p>
                              )}
                            </div>
                          </div>
                          
                          <div className="enhanced-grid">
                            {section.fields.map((fieldInfo, fieldIndex) => (
                              <div 
                                key={`field-${fieldInfo.key}-${fieldIndex}`}
                                className="field-wrapper card-enhanced"
                              >
                                <div className="field-container">
                                  {renderField([fieldInfo.key, fieldInfo.config], `${fieldInfo.key}-${fieldIndex}`, fieldIndex)}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ));
                    })()}
                  </div>

                  <div className="flex justify-end gap-3 pt-4 border-t border-neutral-200 mt-6">
                    {/* Calculate Button */}
                    {isFormulaVisiable && (
                      <div className="flex items-center gap-2">
                        <InfoToolTip 
                          content={
                            <div className="text-sm">
                              <div className="font-medium mb-2">Required for calculation:</div>
                              <div className="space-y-1">
                                <div>• <strong>Quantity:</strong> Enter a positive number</div>
                                <div>• <strong>Greenhouse Gas:</strong> Select gas type</div>
                              </div>
                              <div className="mt-2 text-xs text-neutral-400">
                                Fill in all required fields before calculating
                              </div>
                            </div>
                          }
                          placement="top"
                        />
                        
                        {/* Diagnostic Information */}
                        <div className="text-xs text-neutral-500 bg-neutral-50 px-3 py-2 rounded-md border border-neutral-200">
                          <div className="font-medium mb-1">Service Status:</div>
                          <div className="flex items-center gap-2">
                            <div className={`w-2 h-2 rounded-full ${
                              process.env.REACT_APP_HAYA_IP_ADDRESS ? 'bg-emerald-500' : 'bg-red-500'
                            }`}></div>
                            <span>
                              {process.env.REACT_APP_HAYA_IP_ADDRESS 
                                ? 'AI Service Configured' 
                                : 'AI Service Not Configured'
                              }
                            </span>
                          </div>
                          {process.env.REACT_APP_HAYA_IP_ADDRESS && (
                            <div className="text-xs text-neutral-400 mt-1">
                              Endpoint: {process.env.REACT_APP_HAYA_IP_ADDRESS}
                            </div>
                          )}
                        </div>

                        <Button
                          color="success"
                          size="sm"
                          onClick={testCalculationHandler}
                          className="enhanced-button text-white px-6 py-2 font-medium text-sm rounded-md"
                          isDisabled={isCalculating}
                          startContent={<FontAwesomeIcon icon={faCalculator} className="text-sm" />}
                        >
                          {isCalculating ? (
                            <Spinner color="white" size="sm" />
                          ) : (
                            "Calculate"
                          )}
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Calculation Results Card */}
            {Object.keys(calculationResults).length > 0 && (
              <div className="bg-white rounded-lg border border-neutral-200 shadow-sm p-6 mt-6">
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-8 bg-emerald-500 rounded-full"></div>
                    <div>
                      <h3 className="text-xl font-semibold text-neutral-900">Calculation Results</h3>
                      <p className="text-sm text-neutral-600 mt-1">Emission calculation results</p>
                    </div>
                  </div>

                </div>
                
                <div className="space-y-8">
                  {Object.entries(calculationResults).map(([key, result]) => {
                    if (key === 'error') return null;
                    
                    // Safety check: ensure result has required properties
                    if (!result || typeof result !== 'object') {
                      console.warn(`Invalid result structure for key "${key}":`, result);
                      return null;
                    }
                    
                    // Safety check: ensure result has required properties
                    if (!result.result || !result.reasoning) {
                      console.warn(`Missing required properties for key "${key}":`, result);
                      return null;
                    }
                    
                    // Log the result structure for debugging
                    console.log(`Processing calculation result for "${key}":`, {
                      resultType: typeof result.result,
                      resultValue: result.result,
                      reasoningType: typeof result.reasoning,
                      reasoningValue: result.reasoning
                    });
                    
                    // Convert reasoning to simple text lines for textarea; be careful with mathematical expressions
                    const formatCalculationSteps = (reasoning) => {
                      if (!reasoning) return "";
                      
                      // Handle case where reasoning might be an object
                      let text;
                      if (typeof reasoning === 'object' && reasoning !== null) {
                        text = JSON.stringify(reasoning, null, 2);
                      } else {
                        text = String(reasoning);
                      }
                      
                      text = text.replace(/\r\n/g, '\n');
                      
                      // Only add newlines for actual list markers, not mathematical expressions
                      // Look for numbered bullets: "1. ", "2. " etc. (must have space after dot)
                      text = text.replace(/(^|\n)(\d+)\.\s/g, '$1$2. ');
                      
                      // Look for hyphen bullets: " - " (must have spaces around hyphen)
                      text = text.replace(/(^|\n)\s-\s/g, '$1- ');
                      
                      // Clean up any double newlines
                      text = text.replace(/\n{2,}/g, '\n');
                      
                      return text.trim();
                    };

                    // Extract the correct result from reasoning if the result field seems wrong
                    const extractCorrectResult = (result, reasoning) => {
                      // Handle case where result is an object (e.g., {CO₂e (t): 678.0})
                      if (result && typeof result === 'object' && result !== null) {
                        // Extract the first numeric value from the object
                        const firstValue = Object.values(result).find(val => 
                          typeof val === 'number' || (typeof val === 'string' && !isNaN(parseFloat(val)))
                        );
                        if (firstValue !== undefined) {
                          console.log(`Extracted value from result object: ${firstValue} (original was: ${JSON.stringify(result)})`);
                          return String(firstValue);
                        }
                        // If no numeric value found, return a default
                        return "0";
                      }
                      
                      if (!reasoning) return String(result || "0");
                      
                      const reasoningText = String(reasoning).toLowerCase();
                      
                      // Look for common patterns that indicate the final result
                      const patterns = [
                        // Mathematical calculation pattern: "X t x Y = Z t" (most common)
                        /([\d,]+\.?\d*)\s*(?:t|tonnes?|tons?)\s*[x×]\s*[\d,]+\.?\d*\s*=\s*([\d,]+\.?\d*)\s*(?:t|tonnes?|tons?)/i,
                        // "total CO₂e is X t" or "final result is X t"
                        /(?:total|final result|result is|co₂e is|co2e is)\s+(?:=?\s*)?([\d,]+\.?\d*)\s*(?:t|tonnes?|tons?)/i,
                        // "CO₂e = X t" or "CO2e = X t"
                        /(?:co₂e|co2e)\s*=\s*([\d,]+\.?\d*)\s*(?:t|tonnes?|tons?)/i,
                        // "X t CO₂e" or "X tonnes CO2e"
                        /([\d,]+\.?\d*)\s*(?:t|tonnes?|tons?)\s+(?:co₂e|co2e)/i,
                        // "Therefore, the final result is CO₂e = X"
                        /(?:therefore|thus|hence|final result|result)\s+(?:is|equals?)\s+(?:co₂e|co2e)\s*=\s*([\d,]+\.?\d*)/i,
                        // Simple calculation result: "= X t" or "= X tonnes"
                        /=\s*([\d,]+\.?\d*)\s*(?:t|tonnes?|tons?)/i
                      ];
                      
                      for (const pattern of patterns) {
                        const match = reasoningText.match(pattern);
                        if (match) {
                          // For mathematical calculations, use the result part (after =)
                          const valueToUse = match[2] || match[1];
                          const extractedValue = parseFloat(valueToUse.replace(/,/g, ''));
                          if (!isNaN(extractedValue) && extractedValue > 0) {
                            console.log(`Extracted correct result from reasoning: ${extractedValue} (original was: ${result})`);
                            return extractedValue.toString();
                          }
                        }
                      }
                      
                      // If no pattern matches, try to find the last number followed by "t" or "tonnes"
                      const lastNumberPattern = /([\d,]+\.?\d*)\s*(?:t|tonnes?|tons?)(?:\s|$)/gi;
                      let lastMatch = null;
                      let match;
                      while ((match = lastNumberPattern.exec(reasoningText)) !== null) {
                        lastMatch = match;
                      }
                      
                      if (lastMatch) {
                        const extractedValue = parseFloat(lastMatch[1].replace(/,/g, ''));
                        if (!isNaN(extractedValue) && extractedValue > 0) {
                          console.log(`Extracted last number from reasoning: ${extractedValue} (original was: ${result})`);
                          return extractedValue.toString();
                        }
                      }
                      
                      return String(result || "0");
                    };
                    
                    return (
                      <div key={key} className="border border-neutral-200 rounded-lg p-6 bg-white shadow-sm">
                        <div className="flex items-center justify-between mb-4">
                          <h4 className="text-lg font-semibold text-neutral-800 capitalize flex items-center gap-2">
                            <div className="w-1 h-5 bg-emerald-500 rounded-full"></div>
                            {key.replace(/([A-Z])/g, ' $1').trim()}
                          </h4>
                          <Chip 
                            color="success" 
                            variant="flat" 
                            size="sm"
                            className="text-xs font-medium bg-emerald-100 text-emerald-800 border-emerald-200"
                          >
                            ✓ Calculated
                          </Chip>
                        </div>
                        
                        <div className="space-y-4">
                          {/* Final Result */}
                          <div className="bg-neutral-50 rounded-md border border-neutral-200 p-4">
                            <label className="block text-sm font-medium text-neutral-700 mb-2">
                              Final Result
                            </label>
                            <div className="flex items-center gap-3">
                              <Input
                                value={extractCorrectResult(result.result, result.reasoning) || "0"}
                          isReadOnly
                                className="bg-white border-neutral-200 text-lg font-semibold text-emerald-700 w-full"
                                size="md"
                              />
                              <span className="text-sm text-neutral-600">t CO₂e</span>
                            </div>
                          </div>
                          
                          {/* Calculation Steps and Details */}
                          <div className="bg-neutral-50 rounded-md border border-neutral-200 p-4">
                            <label className="block text-sm font-medium text-neutral-700 mb-3">
                              Calculation Steps & Details
                            </label>
                            <Textarea
                              isReadOnly
                              value={formatCalculationSteps(result.reasoning)}
                              minRows={6}
                          size="sm"
                              className="bg-white border-neutral-200 w-full"
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                
                {/* Action Buttons */}
                <div className="flex justify-center items-center mt-6 pt-6 border-t border-neutral-200">
                  <div className="flex gap-4">
                    <Button
                      color="default"
                      variant="bordered"
                      size="sm"
                      onClick={testCalculationHandler}
                      className="border-neutral-300 hover:border-neutral-400 text-neutral-700 hover:text-neutral-800 px-6 font-medium"
                      isDisabled={isCalculating}
                      startContent={<FontAwesomeIcon icon={faCalculator} className="text-sm" />}
                    >
                      {isCalculating ? (
                        <Spinner color="default" size="sm" />
                      ) : (
                        "Recalculate"
                      )}
                    </Button>
                  </div>
                </div>
              </div>
            )}

            {/* Activity Logs Card */}
            <Card className="border border-neutral-100 shadow-sm mt-6">
              <CardHeader className="px-6 py-4 border-b border-neutral-100 bg-gradient-to-r from-neutral-50 to-white">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-orange-100 rounded-lg">
                    <FontAwesomeIcon icon={faUser} className="text-warning-600 text-sm" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-neutral-900">Activity Logs</h3>
                    <p className="text-sm text-neutral-600 mt-1">Track changes and updates to this metric</p>
                  </div>
                </div>
              </CardHeader>
              <CardBody className={`p-6 ${(responseInfo?.attributes?.Logs || []).length > 3 ? 'max-h-96 overflow-y-auto' : ''}`}>
                <LogsInfo data={responseInfo?.attributes?.Logs || []} />
              </CardBody>
            </Card>

            {/* Helpful Links Section */}
            {links?.length > 0 && (
              <Card className="border border-neutral-100 shadow-sm mt-6">
                <CardHeader className="px-6 py-4 border-b border-neutral-100 bg-gradient-to-r from-neutral-50 to-white">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-success-100 rounded-lg">
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-neutral-900">Helpful Background Reading</h3>
                      <p className="text-sm text-neutral-600 mt-1">Additional resources and documentation</p>
                    </div>
                  </div>
                </CardHeader>
                <CardBody className="p-6">
                  <div className="space-y-2">
                    {links?.map((link, index) => (
                      <div key={index}>
                        <Link
                          href={link.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary-600 hover:text-primary-700 font-medium text-sm"
                        >
                          {link.name}
                        </Link>
                      </div>
                    ))}
                  </div>
                </CardBody>
              </Card>
            )}
          </div>
          </LoadingPage>
        </div>
      </BreadCrumbsPage>
    </div>
  );
};

export default EditMetricForm;